module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamond@2x.0ee9612.jpg";